var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlane = function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 1.6c-.1-.3.1-.6.5-.6h2c.2 0 .4.1.4.3L12.5 8h5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-5l-3.4 6.7c0 .2-.2.3-.4.3h-2c-.3 0-.6-.3-.5-.6L7.9 11H4.8l-.7 2.2c-.1.2-.3.3-.5.3H1.7c-.3 0-.6-.3-.5-.7l1.1-3.3-1.1-3.3c-.1-.4.2-.7.5-.7h1.9c.2 0 .4.1.5.3L4.8 8h3.1L6.2 1.6z"
  })));
};
export default SvgPlane;